Helpful = window.Helpful || {};

Helpful.init = function(options) {
	var $yes = $('#abendingar #fieldset_yesFieldset');
	$yes.wrapInner('<div class="wrap" />');
	$('#abendingar #fieldset_noFieldset input[type=radio]').each(function() {
		$(this).parent().before(this);
	});

	$('#helpful-1').click(function(e) {
		Helpful.helpfulPost();
		$('#fieldset_noFieldset').hide();
	});
	$('#helpful-0').click(function(e) {
		$('#fieldset_noFieldset').slideDown();
		$(this).parent().addClass('selected');
		$('#fieldset_yesFieldset').addClass('open');
		$('body').addClass('helpful-open');

		if ($('body').width() > 992-15) {
			var scrollPosition = $(window).scrollTop() + 287;
			$("html, body").animate({scrollTop: scrollPosition}, 600);
		}
	});
	$('#helpful_submit').click(function(e) {
		Helpful.helpfulPost();
	});
	$('#helpful_cancel').click(function(e) {
		$('#fieldset_noFieldset').slideUp();
		$('#helpful-0').parent().removeClass('selected');
		Helpful.helpfulReset();
	});
	$('#fieldset_noFieldset #elm_reason .radio').click(function() {
		$('#fieldset_noFieldset #extra').focus();
		$('#fieldset_noFieldset #elm_extra label').text(options.language.explain);
	});
};
